<template>
  <ul class="search-bar">
    <li>
      <p>{{ this.data.totalNotSendSms }}</p>
      <span>剩余短信条数</span>
    </li>
    <li>
      <p>{{ this.data.totalSms }}</p>
      <span>累计购买条数</span>
    </li>
    <li>
      <p>{{ this.data.totalSendSms }}</p>
      <span>累计发送条数</span>
    </li>
  </ul>
</template>

<script>
export default {
  name: "CountTitle",
  props: {
    data: {
      require: true,
    },
  },
};
</script>

<style lang="less" scoped>
    @import '@/assets/style/var';
    ul{
        display: flex;
        margin-bottom: 0;
        justify-content: space-around;
        li{
            list-style: none;
            text-align: center;
            p{
                font-size: 40px;
                font-weight: 500;
                line-height: 0;
                color: #699CE4;
            }
            span{
                font-size: 16px;
                color: #616161;
            }
        }
    }

</style>